import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  FGTemplateSelectedIds: [],
  FGTemplateTreeData: [],
  FGTemplateAppliedData: [],
  FGTemplateSearchQuery: "",
  FGTemplateExpandedItems: [],
};

const FGTemplateTreeSlice = createSlice({
  name: "FGTemplateTree",
  initialState,
  reducers: {
    setFGTemplateSelectedIds: (state, action) => {
      state.FGTemplateSelectedIds = action.payload;
    },
    setFGTemplateTreeData: (state, action) => {
      state.FGTemplateTreeData = action.payload;
    },
    setFGTemplateAppliedData: (state, action) => {
      state.FGTemplateAppliedData = action.payload;
    },
    setFGTemplateSearchQuery: (state, action) => {
      state.FGTemplateSearchQuery = action.payload;
    },
    resetFGTemplateSelection: (state) => {
      state.FGTemplateSelectedIds = [];
      state.FGTemplateAppliedData = [];
    },
    setFGTemplateExpandedItems: (state, action) => {
      state.FGTemplateExpandedItems = action.payload;
    },
  },
});

export const {
  setFGTemplateSelectedIds,
  setFGTemplateTreeData,
  setFGTemplateAppliedData,
  setFGTemplateSearchQuery,
  resetFGTemplateSelection,
  setFGTemplateExpandedItems,
} = FGTemplateTreeSlice.actions;

export default FGTemplateTreeSlice.reducer;
